/* tslint:disable */
/* eslint-disable */
/**
 * Optimizely Feature Experimentation API
 * This page documents how to use the Optimizely FX API. With this API you can view and manage Feature Flags and all of their related entities including Variables, Variations, Rules, and Reports.  The base URL is https://api.optimizely.com/flags/v1. Append any paths listed in these docs onto that url in order to make requests to the API.
 *
 * The version of the OpenAPI document: 0.3.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    RuleDetails,
    RuleDetailsFromJSON,
    RuleDetailsFromJSONTyped,
    RuleDetailsToJSON,
    RulesetSummary,
    RulesetSummaryFromJSON,
    RulesetSummaryFromJSONTyped,
    RulesetSummaryToJSON,
} from './';

/**
 * 
 * @export
 * @interface FlagEnvironment
 */
export interface FlagEnvironment {
    /**
     * The ID of the Environment
     * @type {number}
     * @memberof FlagEnvironment
     */
    readonly id?: number;
    /**
     * 
     * @type {string}
     * @memberof FlagEnvironment
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof FlagEnvironment
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof FlagEnvironment
     */
    enabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FlagEnvironment
     */
    has_restricted_permissions?: boolean;
    /**
     * Status of the Flag
     * @type {string}
     * @memberof FlagEnvironment
     */
    status?: string;
    /**
     * Integer representing the priority of the Environment. This is used for ordering in the UI.
     * @type {number}
     * @memberof FlagEnvironment
     */
    priority: number;
    /**
     * Link to enable this flag in the environment
     * @type {string}
     * @memberof FlagEnvironment
     */
    readonly enable_url?: string;
    /**
     * Link to disable this flag in the environment
     * @type {string}
     * @memberof FlagEnvironment
     */
    readonly disable_url?: string;
    /**
     * 
     * @type {Date}
     * @memberof FlagEnvironment
     */
    readonly created_time?: Date;
    /**
     * Map of rules that include rule type as key and summary as value
     * @type {{ [key: string]: RulesetSummary; }}
     * @memberof FlagEnvironment
     */
    rules_summary?: { [key: string]: RulesetSummary; };
    /**
     * 
     * @type {Array<RuleDetails>}
     * @memberof FlagEnvironment
     */
    rules_detail?: Array<RuleDetails>;
}

export function FlagEnvironmentFromJSON(json: any): FlagEnvironment {
    return FlagEnvironmentFromJSONTyped(json, false);
}

export function FlagEnvironmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): FlagEnvironment {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'key': json['key'],
        'name': json['name'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'has_restricted_permissions': !exists(json, 'has_restricted_permissions') ? undefined : json['has_restricted_permissions'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'priority': json['priority'],
        'enable_url': !exists(json, 'enable_url') ? undefined : json['enable_url'],
        'disable_url': !exists(json, 'disable_url') ? undefined : json['disable_url'],
        'created_time': !exists(json, 'created_time') ? undefined : (new Date(json['created_time'])),
        'rules_summary': !exists(json, 'rules_summary') ? undefined : (mapValues(json['rules_summary'], RulesetSummaryFromJSON)),
        'rules_detail': !exists(json, 'rules_detail') ? undefined : ((json['rules_detail'] as Array<any>).map(RuleDetailsFromJSON)),
    };
}

export function FlagEnvironmentToJSON(value?: FlagEnvironment | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'key': value.key,
        'name': value.name,
        'enabled': value.enabled,
        'has_restricted_permissions': value.has_restricted_permissions,
        'status': value.status,
        'priority': value.priority,
        'rules_summary': value.rules_summary === undefined ? undefined : (mapValues(value.rules_summary, RulesetSummaryToJSON)),
        'rules_detail': value.rules_detail === undefined ? undefined : ((value.rules_detail as Array<any>).map(RuleDetailsToJSON)),
    };
}


